import {
  type ISelectInputProps,
  SelectInput,
} from '@framework/form/inputs/SelectInput.tsx';
import { type DefaultOptionType } from 'antd/es/select';
import { useMemo } from 'react';
import { SimilInputSpan } from '../../../../../../ui/form/SimilInputSpan.tsx';
import { $SpaceCompact } from '../../../../../../ui/form/SpaceCompact.ts';
import {
  type IAsyncService,
  type IAsyncServiceParameter,
} from '../../../../../expressions/repository/async/context/IAsyncService.ts';

export interface IServiceOutputSelectProps {
  label?: string;
  help?: string;
  service: IAsyncService;
  name: string;
  onChange?: ISelectInputProps<
    DefaultOptionType & { context: IAsyncServiceParameter }
  >['onChange'];
  mode?: ISelectInputProps<
    DefaultOptionType & { context: IAsyncServiceParameter }
  >['mode'];
}

/**
 * Componente grafico per la selezione di un output di un servizio, affiancato a una label.
 */
export function ServiceOutputSelect(props: IServiceOutputSelectProps) {
  const { label, service, name, help, mode } = props;

  const options = useMemo(() => {
    return (
      service.outputs.map(o => ({
        // La label mostrata deve essere quella originale configurata dall'utente
        // Per retrocompatibilità, se non è presente, uso il nome del campo
        // per i campi non additati i due valori saranno uguali nelle nuove configurazioni
        label: o.sourcePath ?? o.name,
        value: o.name,
        context: o,
      })) ?? []
    );
  }, [service]);

  return (
    <$SpaceCompact block size="large">
      {label && <SimilInputSpan>{label}</SimilInputSpan>}
      <SelectInput<DefaultOptionType & { context: IAsyncServiceParameter }>
        allowClear
        showSearch
        style={{ width: '100%' }}
        name={name}
        options={options}
        onChange={
          props.onChange
            ? props.onChange
            : (value, _, onChange) => {
                onChange(value ?? null);
              }
        }
        mode={mode}
      />
    </$SpaceCompact>
  );
}
